import logo from './logo.svg';
import './App.css';
import React, {useEffect, useState} from 'react';
import axios from 'axios';

function App() {
    const[data, setData] = useState('')
    useEffect(()=>{
        axios.get('/api/data') //여기로 오는 것들은
        .then(react => {
            setData(react.data)
            })
        .catch(err =>{
            console.err('데이터 에러가 났어요',err);
            })
    },[]);

  return (
    <div className="App">

     <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <div>받은 값이야 : {data}</div>
      </header>
    </div>
  );
}

export default App;
